/**
 * Labstep
 *
 * @module components/PermissionRole/Form/fields
 * @desc Fields for PermissionRole
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';

export const fieldName: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: 'Name',
  name: 'name',
  validation: rules.permission_role.name,
  placeholder: 'Enter name',
};
